import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Typography from '@/components/typography';

type Props = {
  idx?: number;
  hideIdx?: boolean;
  dotColor?: string;
};

export const CardDot: FC<Props> = ({
  idx = undefined,
  hideIdx = false,
  dotColor = undefined,
}) => {
  if (hideIdx && dotColor) {
    return (
      <div className={twMerge('m-auto mr-2 h-3 w-3 rounded-full', dotColor)} />
    );
  }

  return (
    <div className="mr-2 h-5 min-w-[20px] rounded-full bg-green-utility text-white">
      <Typography className="text-center text-[14px] leading-5">
        {idx !== undefined ? idx + 1 : ''}
      </Typography>
    </div>
  );
};
